import { render } from "./MarginalGains.vue?vue&type=template&id=5776d41e"
import script from "./MarginalGains.vue?vue&type=script&setup=true&lang=js"
export * from "./MarginalGains.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Pages/Dashboard/Table/MarginalGains.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5776d41e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5776d41e', __exports__)) {
    api.reload('5776d41e', __exports__)
  }
  
  module.hot.accept("./MarginalGains.vue?vue&type=template&id=5776d41e", () => {
    api.rerender('5776d41e', render)
  })

}


export default __exports__